/**
 * Asynchronously loads the component for MyPrograms
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
